package com.nonopn.skywatcher.common.app.home

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.ButtonDefaults
import androidx.compose.material.OutlinedButton
import androidx.compose.material.ScaffoldState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.dokar.sonner.TextToastAction
import com.dokar.sonner.Toaster
import com.dokar.sonner.rememberToasterState
import com.nonopn.skywatcher.common.app.portfolio.main.NoThunderDetectionSelectedContent
import com.nonopn.skywatcher.common.app.portfolio.selected.ThunderDetectionSelectedContent
import com.nonopn.skywatcher.common.app.portfolio.selected.ThunderDetectionSelectedModel
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.app_login_title
import com.nonopn.skywatcher.common.app.res.app_main_title
import com.nonopn.skywatcher.common.login.SessionScreen
import com.nonopn.skywatcher.design.appbar.AppBarStateProvider
import com.nonopn.skywatcher.design.init.InitializeScreen
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.design.widgets.BottomSpacer
import eu.codlab.compose.widgets.StatusBarAndNavigation
import eu.codlab.compose.widgets.TextNormal

val LocalMenuState: ProvidableCompositionLocal<ScaffoldState?> =
    compositionLocalOf { null }
val LocalThunderDetectionModel = compositionLocalOf<ThunderDetectionSelectedModel> {
    error("No StaticModel, check LocalThunderDetectionModel")
}

val LocalAppBarProvider = compositionLocalOf<AppBarStateProvider> {
    error("No StaticModel, check LocalThunderDetectionModel")
}

@Composable
@Suppress("LongMethod", "ComplexMethod")
fun AppContent() {
    StatusBarAndNavigation()

    val model = LocalApp.current
    val toaster = rememberToasterState()
    model.toaster = toaster

    val currentState by model.states.collectAsState()

    BottomSpacer {
        Toaster(
            state = toaster,
            containerPadding = PaddingValues(
                vertical = it + 16.dp
            ),
            actionSlot = { toast ->
                val action = toast.action
                if (action !is TextToastAction) return@Toaster

                OutlinedButton(
                    onClick = { action.onClick(toast) },
                    contentPadding = PaddingValues(horizontal = 16.dp, vertical = 16.dp),
                    colors = ButtonDefaults.buttonColors(backgroundColor = AppColor.Black)
                ) {
                    TextNormal(
                        action.text,
                        color = AppColor.WhiteCream
                    )
                }
            }
        )
    }

    if (!currentState.initialized) {
        InitializeScreen(
            LocalApp.current,
            Modifier.fillMaxSize()
        )
        return
    }

    if (null == currentState.apiProvider) {
        SessionScreen(
            Modifier.fillMaxSize(),
            appMainTitle = Res.string.app_main_title,
            loginTitle = Res.string.app_login_title,
            loginCaller = model
        )
        return
    }

    val thunderDetection = currentState.selectedThunderDetection
    if (null == thunderDetection) {
        NoThunderDetectionSelectedContent(model,)
    } else {
        ThunderDetectionSelectedContent(model, thunderDetection)
    }
}
